export const messages = {
  en: {
    refundDepositFee: {
      title: 'Refund Deposit',
      unrefunded: 'Unrefunded',
      refunded: 'Refunded',
      pendingReview: 'Pending Review',
      printReceipt: 'Reprint Receipt',
      alertText: 'Are you sure you want to refund the deposit?'
    },
    payFeeDeposit: {
      payerObject: 'Payer',
      feeItem: 'Fee Item',
      timePeriod: 'Time Period',
      amount: 'Amount',
      paymentTime: 'Payment Time',
      status: 'Status',
      operation: 'Operation',
      refundDeposit: 'Refund Deposit',
      detail: 'Detail',
      title: 'Deposit Information',
      depositInfo: 'Deposit Information',
      refresh: 'Refresh',
      payerObj: 'Payer Object',
      feeName: 'Fee Item',
      timeRange: 'Time Range',
      refund: 'Refund'
    },
    returnPayFee: {
      fillRefundReason: 'Fill Refund Reason',
      orderId: 'Order ID',
      orderType: 'Order Type',
      payOrder: 'Payment Order',
      preOrder: 'Prepaid Order',
      payerObjName: 'Payment Object',
      ownerName: 'Owner',
      feeDetails: 'Fee Details',
      feeName: 'Fee Item',
      feeTimePeriod: 'Payment Period',
      receivedAmount: 'Received Amount',
      payment: 'Payment',
      monthUnit: '(Months)',
      cycle: 'Cycle',
      receivableAmount: 'Receivable Amount',
      paymentTime: 'Payment Time',
      refundReason: 'Refund Reason',
      reasonRequired: 'Refund reason is required',
      reasonMaxLength: 'Refund reason cannot exceed 200 characters',
      reasonPlaceholder: 'Please enter refund reason',
      submitRefund: 'Submit Refund Application',
      selectFeeItems: 'Please select fee items to refund',
      operationSuccess: 'Operation successful',
      operationFailed: 'Operation failed',
      fetchError: 'Failed to fetch fee order details',
      notFound: 'No corresponding fee order information found'
    },
    applyRefundDeposit: {
      refundDeposit: 'Apply Refund Deposit',
      feeItem: 'Fee Item',
      amount: 'Amount',
      chargingObject: 'Payment Object',
      way: 'Refund Method',
      cash: 'Cash',
      toPrePay: 'To Prepaid Account',
      select: 'Select',
      refundReason: 'Refund Reason',
      refundReasonRequired: 'Refund reason is required',
      cancel: 'Cancel',
      submit: 'Submit',
      selectPrePayFee: 'Please select prepaid fees',
      operationSuccess: 'Operation successful',
      operationFailed: 'Operation failed',
      loadFeeRuleFailed: 'Failed to load fee rules'
    }
  },
  zh: {
    refundDepositFee: {
      title: '退押金',
      unrefunded: '未退押金',
      refunded: '已退押金',
      pendingReview: '待审核',
      printReceipt: '补打退款单',
      alertText: '押金退款后自动存到账户中，您可以从账户中选择缴费，如果退现金给业主，请到业务首页面退押金！'

    },
    payFeeDeposit: {
      payerObject: '收费对象',
      feeItem: '费用项',
      timePeriod: '时间段',
      amount: '金额',
      paymentTime: '缴费时间',
      status: '状态',
      operation: '操作',
      refundDeposit: '退押金',
      detail: '详情',
      title: '押金信息',
      depositInfo: '押金信息',
      refresh: '刷新',
      payerObj: '收费对象',
      feeName: '费用项',
      timeRange: '时间段',
      // amount: '金额',
      // paymentTime: '缴费时间',
      // operation: '操作',
      refund: '退押金'
    },
    returnPayFee: {
      fillRefundReason: '填写退费原因',
      orderId: '订单号',
      orderType: '订单类型',
      payOrder: '缴费单',
      preOrder: '预存单',
      payerObjName: '收费对象',
      ownerName: '业主',
      feeDetails: '费用明细',
      feeName: '费用项',
      feeTimePeriod: '缴费时间段',
      receivedAmount: '实收金额',
      payment: '缴费',
      monthUnit: '(单位月)',
      cycle: '周期',
      receivableAmount: '应收金额',
      paymentTime: '缴费时间',
      refundReason: '退费原因',
      reasonRequired: '退费原因不能为空',
      reasonMaxLength: '退费原因不能超过200个字符',
      reasonPlaceholder: '请输入退费原因',
      submitRefund: '提交退费申请',
      selectFeeItems: '请选择需要退费的费用项',
      operationSuccess: '操作成功',
      operationFailed: '操作失败',
      fetchError: '获取费用订单详情失败',
      notFound: '未找到对应的费用订单信息'
    },
    applyRefundDeposit: {
      refundDeposit: '申请退押金',
      feeItem: '费用项',
      amount: '金额',
      chargingObject: '收费对象',
      way: '退费方式',
      cash: '现金',
      toPrePay: '退到预付收款',
      select: '选择',
      refundReason: '退费原因',
      refundReasonRequired: '退费原因不能为空',
      cancel: '取消',
      submit: '提交',
      selectPrePayFee: '请选择预付费用',
      operationSuccess: '操作成功',
      operationFailed: '操作失败',
      loadFeeRuleFailed: '获取费用规则失败'
}
  },
  'zh-TW': {
    refundDepositFee: {
      title: '退押金',
      unrefunded: '未退押金',
      refunded: '已退押金',
      pendingReview: '待審核',
      printReceipt: '補打退款單',
      alertText: '押金退款後自動存到帳戶中，您可以從帳戶中選擇繳費，如果退現金給業主，請到業務首頁面退押金！'
    },
    payFeeDeposit: {
      payerObject: '收費對象',
      feeItem: '費用項',
      timePeriod: '時間段',
      amount: '金額',
      paymentTime: '繳費時間',
      status: '狀態',
      operation: '操作',
      refundDeposit: '退押金',
      detail: '詳情',
      title: '押金資訊',
      depositInfo: '押金資訊',
      refresh: '刷新',
      payerObj: '收費對象',
      feeName: '費用項',
      timeRange: '時間段',
      refund: '退押金'
    },
    returnPayFee: {
      fillRefundReason: '填寫退費原因',
      orderId: '訂單號',
      orderType: '訂單類型',
      payOrder: '繳費單',
      preOrder: '預存單',
      payerObjName: '收費對象',
      ownerName: '業主',
      feeDetails: '費用明細',
      feeName: '費用項',
      feeTimePeriod: '繳費時間段',
      receivedAmount: '實收金額',
      payment: '繳費',
      monthUnit: '(單位月)',
      cycle: '週期',
      receivableAmount: '應收金額',
      paymentTime: '繳費時間',
      refundReason: '退費原因',
      reasonRequired: '退費原因不能為空',
      reasonMaxLength: '退費原因不能超過200個字元',
      reasonPlaceholder: '請輸入退費原因',
      submitRefund: '提交退費申請',
      selectFeeItems: '請選擇需要退費的費用項',
      operationSuccess: '操作成功',
      operationFailed: '操作失敗',
      fetchError: '獲取費用訂單詳情失敗',
      notFound: '未找到對應的費用訂單資訊'
    },
    applyRefundDeposit: {
      refundDeposit: '申請退押金',
      feeItem: '費用項',
      amount: '金額',
      chargingObject: '收費對象',
      way: '退費方式',
      cash: '現金',
      toPrePay: '退到預付收款',
      select: '選擇',
      refundReason: '退費原因',
      refundReasonRequired: '退費原因不能為空',
      cancel: '取消',
      submit: '提交',
      selectPrePayFee: '請選擇預付費用',
      operationSuccess: '操作成功',
      operationFailed: '操作失敗',
      loadFeeRuleFailed: '獲取費用規則失敗'
    }
  }
}